<template>
    <!-- Search -->
    <div class="center-search-types">
        Search By:
        <q-radio dense v-model="searchType" class="search-types" color="red" val="candidate" label="Candidate" />
        <!-- <q-radio dense v-model="searchType" color="red" val="party" label="Party" /> -->
        <q-radio dense v-model="searchType" class="search-types" color="red" val="office" label="Office" />
        <!-- <q-radio dense v-model="searchType" color="red" val="district" label="District" /> -->
        <q-radio dense v-model="searchType" class="search-types" color="red" val="donor" label="Donor" />
    </div>

    <q-btn v-show="global.candidate!=null" id="backButton" class="col-1" round color="red" icon="arrow_back"
        @click="back" />

    <q-input ref="searchBox" clearable autofocus outlined color="red" v-model="searched" :label="searchLabel"
        :hint="candidateCount" class="center-search text-h6">
        <template v-slot:prepend>
            <q-icon name="person_search" />
        </template>

    </q-input>



    <div class="center-search-types">
        <q-btn size="16px" color="primary" class="q-mr-sm left" label="All candidates" @click="showAllCandidates"
            icon="groups">

        </q-btn>

        <q-btn size="16px" color="orange" class="text-black" label="Your Ballot" @click="ballotCandidatesDistrict"
            icon="ballot">

        </q-btn>

        <!-- <q-btn size="16px;" color="white" class="text-black" label="Voting Centers" @click="votingCenterClicked"
            icon="business">

        </q-btn> -->

    </div>

    <!-- Results -->
    <div v-if="searchResults.length>0">
        <q-scroll-area style="height: calc(100vh - 100px);">
            <q-list separator class="q-pa-md" v-model="selected">
                <q-item v-for="candidate in searchResults" clickable v-ripple @click="selectedItem(candidate)">
                    <q-item-section>
                        <q-item-label class="text-h6">{{candidate.Name}}</q-item-label>
                        <q-item-label class="text-red">Republican</q-item-label>
                        <q-item-label class="text-grey">{{candidate.Office}}</q-item-label>
                        <q-item-label class="text-grey">District:{{candidate.District}}</q-item-label>
                        <q-item-label v-if="candidate.YrElected>0" class="text-grey">Year
                            Elected:{{candidate['YrElected']}}</q-item-label>



                    </q-item-section>

                    <q-item-section avatar v-if="candidate.Donors.length>0">
                        <q-icon color="grey" name="paid">
                            <q-tooltip anchor="top middle">
                                Has info in the Funding tab.
                            </q-tooltip>
                        </q-icon>

                    </q-item-section>

                    <q-space />

                    <q-item-section avatar v-if="candidate.voted">
                        <q-icon color="grey" name="receipt_long">
                            <q-tooltip anchor="top middle">
                                Has info in the Voting tab.
                            </q-tooltip>
                        </q-icon>

                    </q-item-section>

                    <q-item-section avatar v-if="candidate.Notes">
                        <q-icon color="grey" name="newspaper">
                            <q-tooltip anchor="top middle">
                                Has Notes in the Detail tab.
                            </q-tooltip>
                        </q-icon>

                    </q-item-section>

                </q-item>

            </q-list>
        </q-scroll-area>
    </div>

</template>


<style scoped>
    .center-search {
        margin: 10px;
        margin-left: 48px;
        margin-right: 5px;
    }

    .center-search-types {
        text-align: center;

        font-size: .8em;
        margin: 5px;

    }

    .search-types {
        margin-left: 2em;
    }

    #backButton {
        min-width: 32px;
        min-height: 32px;
        position: absolute;
        left: 10px;
        top: 95px;
    }
</style>

<script>
    import { collection, getDocs, query, doc, orderBy } from 'firebase/firestore';
    import { global } from './Global.js';

    export default {
        name: "Search",
        data() {
            return {
                error: "",

                candidates: [],
                searched: "",
                searchResults: [],
                selected: {},
                candidateSelected: false,

                lastSearch: "",

                searchType: "candidate",

                searchLabel: "Search for a candidate.",

                global
            }

        },
        mounted() {

            this.get();
        },
        watch: {
            searchType() {
                this.searched = "";
                this.searchResults = [];

                this.$refs.searchBox.$el.focus();

                switch (this.searchType) {
                    case "candidate":
                        this.searchLabel = "Search for a candidate.";
                        break;

                    case "office":
                        this.searchLabel = "Search based on an office.";
                        break;

                    case "donor":
                        this.searchLabel = "Search for candidates based on their donors.";
                        break;

                    // case "district":
                    //     this.searchLabel = "Search for candidates based on their district.";
                    //     break;



                }

            },
            searched() {

                if (this.candidateSelected) {
                    this.candidateSelected = false;
                    return;
                }

                if (this.searched == "" || this.searched == null) {
                    this.searchResults = [];
                    global.candidate = null;

                    return;
                }

                const searchedLowerCase = this.searched.toLowerCase();
                global.donorMatch = this.searched.toUpperCase();

                this.searchResults = this.candidates.filter((can) => {

                    switch (this.searchType) {
                        case "candidate":
                            return can.Name.toLowerCase().includes(searchedLowerCase);
                        case "office":
                            return can.Office.toLowerCase().includes(searchedLowerCase);
                        case "donor":
                            let match = false;


                            can.Donors.some((donor) => {
                                donor.searchMatch = false;

                                if (donor.Name.match(global.donorMatch)) {
                                    match = true;

                                    donor.searchMatch = true;
                                    // return true;
                                }
                            });

                            return match;


                    }

                });



            }
        },
        computed: {
            candidateCount() {
                return "Search count: " + this.searchResults.length;

            }
        },
        methods: {
            back() {
                this.candidateSelected = false;

                this.searched = this.lastSearch;

                global.candidate = null;

            },
            showAllCandidates() {
                this.candidateSelected = true;
                this.searched = "";
                this.searchResults = this.candidates;
            },
            selectedItem(candidate) {
                this.lastSearch = this.searched;

                this.candidateSelected = true;

                this.searched = candidate.Name;

                global.candidate = candidate;

                this.searchResults = [];

            },
            ballotCandidatesDistrict() {
                window.open("https://ballotpedia.org/Alabama_Sample_Ballot", "_blank");
            },
            votingCenterClicked() {
                window.open("https://myinfo.alabamavotes.gov/voterview/");
            },

            async get() {

                const ref = collection(this.fire_db, "candidatesWithDonors");
                const q = await getDocs(query(ref, orderBy("Name")));

                q.forEach((doc) => {
                    let can = doc.data();

                    can = this.filterData(can);

                    can.Donors = this.sortDonors(can.Donors);

                    this.candidates.push(can);

                });

            },
            sortDonors(donors) {
                return donors.sort((a, b) => (a.Name > b.Name) ? 1 : -1);
            },
            filterData(candidate) {

                // if (candidate.Name == "Stan Cooke") debugger;
                if (candidate.Donors.length > 1) {
                    let total = 0;

                    candidate.Donors.forEach((d) => {
                        total += d.Amount;
                    });

                    candidate.DonorTotal = total;

                    const uniqueDonors = [...new Set(candidate.Donors.map(x => x.Name))];

                    candidate.uniqueDonors = uniqueDonors.length;

                }

                candidate.voted = candidate.gasTax || candidate.antiAbortion || candidate.healthFreedom || candidate.constitutionalCarry || candidate.electionIntegrity || candidate.againstAllMandates || candidate.repealStateHealthPowers || candidate.againstIllegals;
                // candidate.voteCount = this.voteCount(candidate.gasTax) + this.voteCount(candidate.antiAbortion) + this.voteCount(candidate.healthFreedom) +
                //     this.voteCount(candidate.constitutionalCarry) + this.voteCount(candidate.electionIntegrity) + this.voteCount(candidate.againstAllMandates)
                //     + this.voteCount(candidate.repealStateHealthPowers) + this.voteCount(candidate.againstIllegals);

                // console.log(candidate.Name, candidate.voteCount);
                return candidate;
            }
            // voteCount(vote) {
            //     if (vote > 0) return 1;

            //     return 0;
            // }
        }

    }
</script>